import React, { useState, useEffect } from "react";
import { useLocation } from "@reach/router";

import DashboardIcon from "../../assets/images/Icons/admin/dashboard.svg";
import ManageJobsIcon from "../../assets/images/Icons/admin/mjobs.svg";
import ApplicantIcon from "../../assets/images/Icons/admin/applicant_icon.svg";
import BlogIcon from "../../assets/images/Icons/admin/blog_icon.svg";
import DownArrow from "../../assets/images/Icons/admin/down_arrow.svg";
import NavItem from "../../utils/adminnav";

const SubNavbar = () => {
    const location = useLocation();
    const [activeItem, setActiveItem] = useState("");

    useEffect(() => {
        const currentPath = location.pathname;
        setActiveItem(currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath);
    }, [location.pathname]);

    const navbarItems = [
        {
            path: "/admin/hr-admin-dashboard",
            label: "Dashboard",
            icon: DashboardIcon,
            icon1: DownArrow
        },
        {
            path: "/admin/list-of-all-jobs",
            label: "Manage Jobs",
            icon: ManageJobsIcon,
            icon1: DownArrow,
        },
        {
            path: "/admin/applicant-profiles",
            label: "Applicant Data",
            icon: ApplicantIcon,
            icon1: DownArrow
        },
        {
            path: "/admin/blogs-data",
            label: "Blogs",
            icon: BlogIcon,
            icon1: DownArrow
        },
    ];

    return (
        <div className="admin-sub-header">
            <div className="admin-navbar">
                {navbarItems.map((item) => (
                    <NavItem
                        key={item.path}
                        path={item.path}
                        label={item.label}
                        icon={item.icon}
                        icon1={item.icon1}
                        isActive={activeItem === item.path}
                        onClick={() => setActiveItem(item.path)}
                    />
                ))}
            </div>
        </div>
    );
};

export default SubNavbar;
